// Central role helpers for the RBAC matrix (admin / agent / accounts / hr).
// `agent` is the unchanged daily-ops baseline; `admin` sees everything.

export const getRole = (user) => (user?.role || '').toLowerCase();

export const isAdmin = (user) => getRole(user) === 'admin';
export const isAgent = (user) => getRole(user) === 'agent';
export const isAccounts = (user) => getRole(user) === 'accounts';
export const isHr = (user) => getRole(user) === 'hr';

// Where each role lands / "home" when redirected away from a disallowed route.
export const roleHome = (role) => {
  const r = (role || '').toLowerCase();
  if (r === 'accounts') return '/accounts';
  if (r === 'hr') return '/hr';
  return '/';
};

// Accounts = finance + view travellers/trips/vouchers + reports + tax calendar.
const ACCOUNTS_PREFIXES = [
  '/accounts', '/clients', '/quotes', '/vouchers', '/voucher-preview',
  '/invoices', '/finance', '/ledger', '/payment-links', '/vendors',
  '/analytics', '/reports', '/accounting', '/compliance', '/whatsapp',
  '/settings', '/change-password',
];

// HR = own dashboard + team management + own security.
const HR_PREFIXES = ['/hr', '/users', '/settings', '/change-password'];

// Accounts is VIEW-ONLY on travellers & trips — block the create/edit routes
// (backend also 403s these; this keeps the UX clean by redirecting home).
const ACCOUNTS_WRITE_DENY = [
  /^\/clients\/new/,
  /^\/clients\/[^/]+\/edit/,
  /^\/quotes\/new/,
  /^\/quotes\/[^/]+\/edit/,
];

// Admin + agent keep their existing (unchanged) full access. Accounts and HR
// are scoped to their allow-listed prefixes; everything else redirects home.
export const isPathAllowed = (role, pathname) => {
  const r = (role || '').toLowerCase();
  if (!r || r === 'admin' || r === 'agent') return true;
  if (r === 'accounts') {
    if (ACCOUNTS_WRITE_DENY.some((re) => re.test(pathname))) return false;
    return ACCOUNTS_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'));
  }
  const allowed = r === 'hr' ? HR_PREFIXES : [];
  return allowed.some((p) => pathname === p || pathname.startsWith(p + '/'));
};
